
        var result = require("!!../../../../node_modules/css-loader/index.js!./mailing.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/marketing/mailing/mailing.component.css
// module id = 2534
// module chunks = 1